import { supabase } from "./supabase";

/**
 * Upsert user into public.users table when they sign in (email or Google).
 * Keeps dashboard users table in sync with auth.
 */
export async function upsertUserToDashboard(user) {
  if (!user) return null;
  try {
    const row = {
      id: user.id,
      email: user.email ?? "",
      full_name: user.user_metadata?.full_name ?? user.user_metadata?.name ?? user.email?.split("@")[0] ?? "",
      role: user.user_metadata?.role ?? "customer",
      last_sign_in_at: user.last_sign_in_at ?? new Date().toISOString(),
    };
    const { data, error } = await supabase
      .from("users")
      .upsert(row, { onConflict: "id" })
      .select()
      .single();

    if (error) {
      console.warn("Could not upsert user to dashboard:", error);
      return null;
    }
    return data;
  } catch (err) {
    console.warn("upsertUserToDashboard error:", err);
    return null;
  }
}
